import LoadingOverlayComponent from /* webpackChunkName: "loading-overlay-component" */ './LoadingOverlay';

const LoadingOverlay = () => {
  return <LoadingOverlayComponent />;
};

export default LoadingOverlay;
